import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    school: "St Mary's College",
    quote: "St Mary's College students achieved 14% higher scores in maths tests after using Eedi in a mini-trial, demonstrating significant progress.",
    link: 'https://eedi.com/case-studies/st-marys-college-uk'
  }, {
    school: 'All Saints Catholic Academy',
    quote: "All Saints Catholic Academy, Mansfield, saw students surpass target grades and low-ability groups thrive, thanks to Eedi's tailored support and engaging content.",
    link: 'https://eedi.com/case-studies/all-saints-catholic-academy-uk'
  }, {
    school: 'Ecclesbourne School',
    quote: 'Ecclesbourne School, UK, achieved real results with Eedi, improving student performance and informing lesson planning through targeted interventions and retrieval practice.',
    link: 'https://eedi.com/case-studies/ecclesbourne-school-uk'
  }];
  return <section className="py-20 bg-gradient-to-br from-purple-100 to-blue-100 relative overflow-hidden" data-id="element-272">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-20 h-20 bg-white rounded-full opacity-20" data-id="element-273"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 bg-white rounded-full opacity-20" data-id="element-274"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-275">
        <div className="text-center mb-16" data-id="element-276">
          <h2 className="text-3xl font-bold mb-4" data-id="element-277">Hear from Our Partners</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-blue-500 mx-auto mb-6" data-id="element-278"></div>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto" data-id="element-279">
            Discover the impact Eedi has had on other schools and how they've
            benefited from our partnership.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-280">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-all duration-300 transform hover:translate-y-[-4px] border border-gray-100" data-id="element-281">
              <div className="absolute top-4 left-4 text-purple-200 opacity-30" data-id="element-282">
                <QuoteIcon size={40} data-id="element-283" />
              </div>
              <div className="relative z-10" data-id="element-284">
                <h3 className="font-bold text-xl mb-4 text-purple-700" data-id="element-285">
                  {testimonial.school}
                </h3>
                <p className="text-gray-700 mb-6 italic" data-id="element-286">
                  "{testimonial.quote}"
                </p>
                <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 font-medium inline-flex items-center border-b border-blue-600 pb-1 transition-colors" data-id="element-287">
                  Read full case study
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}